import React from 'react';

import { Icon } from 'opencare-crown';

import { LoadingContainer } from './styled-components';

export const Loading = () => (
  <LoadingContainer data-testid="loading">
    <Icon type="loading" style={{ fontSize: '50px', marginTop: '8px' }} aria-label="Loading" />
  </LoadingContainer>
);

